<template>
    <div class="impact-section" id="impact">
      <h2>{{ title }}</h2>
      <p class="description">{{ description }}</p>
      <p class="meter-description" v-if="showMeterDescription">{{ meterDescription }}</p>
      <div class="categories">
        <div
          class="category-section"
          v-for="(category, index) in categories"
          :key="index"
        >
          <div
            class="category-header"
            :class="{ highlight: category.highlightHeader }"
          >
            <span>{{ category.title }}</span>
          </div>
          <div class="metric-container">
            <div class="metric" v-for="(item, index) in category.metrics" :key="index">
              <div class="metric-label">{{ item.label }}</div>
              <div class="metric-value">{{ item.value }}</div>
            </div>
            <div class="value" v-for="(item, index) in category.metrics" :key="index">

        </div>
          </div>
        </div>
      </div>
  
       
    </div>
    <!-- New Section: See How Your Onboarding Can Create Change -->
    <div class="onboarding-section">
        <h3 class="onboarding-title">See how your onboarding can create change</h3>
        <button class="onboarding-button" @click="goToImpactMeter">Explore Our Impact Meter</button>
    </div>
  </template>
  
  <script>
import { useRouter } from 'vue-router';

export default {
  name: 'ImpactSection',
  props: {
    title: String,
    description: String,
    meterDescription: String,
    categories: Array,
    showMeterDescription: {
      type:Boolean,
      default:false
    }
  },
  setup() {
    const router = useRouter();

    const goToImpactMeter = () => {
      // Navigate to the homepage
      router.push('/').then(() => {
        // Wait for the navigation to complete, then scroll to the ImpactMeter section
        setTimeout(() => {
          const impactMeterSection = document.getElementById('impactMeter');
          if (impactMeterSection) {
            // Calculate the position of the ImpactMeter section
            const elementPosition = impactMeterSection.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition ; // Adjust for navbar height (e.g., 80px)

            // Scroll to the ImpactMeter section
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }
        }, 100); // Small delay to ensure the page has loaded
      });
    };

    return {
      goToImpactMeter,
    };
  },
};
</script>
  
  <style scoped>
.impact-section {
  padding: 40px 0;
  text-align: left;
  display: flex; /* Add flexbox to the parent */
  flex-direction: column; /* Stack children vertically */
  align-items: center; /* Center children horizontally */
}

h2 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.description,
.meter-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.categories {
  max-width: 800px; /* Keep the max-width for control */
  display: flex;
  flex-direction: column;
  gap: 15px;
  
  width: 100%; /* Ensure it takes full available width up to max-width */
}

.category-section {
  display: flex;
  align-items: stretch;
  text-align: left;
  background: #f9f9f9;
  border-radius: 8px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.category-header {
  background: #fe918b;
  color: white;
  padding: 15px;
  border-radius: 8px 0 0 8px;
  font-weight: bold;
  text-align: center;
  width: 200px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
}

.category-header.highlight {
  background-color: #ff6860;
  color: white;
}

.container {
  display: flex;
  width: 100%;
}

.metric-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  /* gap: 12px; */
}

.value-container {
  background: #33B0F8;
  border-radius: 0px 8px 8px 0px;
  font-weight: bold;
  text-align: center;
  width: 100px;
  padding: 1rem;
}

.metric {
  display: flex;
 
  justify-content: space-between;
  padding: 7px;
  
}
  
.metric-label {
  flex: 2;
  
  font-size: 14px;
  color: #333;
  text-align: right;
}

.metric-value {
  
  flex: 0 0 80px;
  font-size: 14px;
  font-weight: bold;
  color: #33B0F8;
  text-align: right;
}
  
/* New Section Styles */
.onboarding-section {
  background-color: #D6F2FF; /* Light blue background */
  max-width: 930px;
  border-radius: 10px;
  padding: 50px;
  text-align: center;
  margin-bottom: 40px;
 
}

.onboarding-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.onboarding-button {
  background-color: #007AB2; /* Blue button color */
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  /* font-weight: bold; */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.onboarding-button:hover {
  background-color:#00AEFF; 
}

@media (max-width: 1068px) {
  .category-section {
    flex-direction: column;
  }

  .category-header {
    width: 100%;
    border-radius: 8px 8px 0 0;
  }

  .metric-container {
    padding: 1rem;
  }
  .metric-label {
    flex: 2;
    
    font-size: 14px;
    color: #333;
    text-align: left;
  }
}

@media (max-width: 768px) {
  h2 {
    font-size: 32px;
  }

  .description,
  .meter-description {
    font-size: 14px;
  }

  .category-header {
    font-size: 14px;
  }

  .metric-label,
  .metric-value {
    font-size: 12px;
  }

  /* .onboarding-section {
    padding: 20px;
  } */

  .onboarding-title {
    font-size: 20px;
  }

  .onboarding-button {
    font-size: 14px;
    padding: 8px 16px;
  }
}
</style>